const layoutClasses =
  "grid grid-cols-[1.5fr_480px] gap-8 h-full min-h-0 pointer-events-none";

const colLeftClasses = "overflow-y-auto min-h-0 pr-2 pb-6";
const colRightClasses = "flex flex-col gap-4 overflow-y-auto min-h-0 pr-2 pb-6";
const docWrapperClasses =
  "bg-white border border-border rounded-2xl p-6 min-h-full";
const colHeadingClasses =
  "text-base font-bold uppercase tracking-[calc(var(--spacing)*0.2)] text-subtle mb-0";

const cardClasses =
  "bg-white border border-border rounded-xl p-4 flex flex-col gap-2.5";

const blockBase =
  "relative overflow-hidden bg-primary-surface rounded-lg " +
  "after:content-[''] after:absolute after:inset-0 after:-translate-x-full " +
  "after:bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,0.6)_45%,transparent_100%)] " +
  "after:animate-skeleton-shimmer";

const docTitleClasses = `${blockBase} h-7 w-[45%] mb-[calc(var(--spacing)*4.5)]`;
const docLineClasses = `${blockBase} h-3.5 w-full mb-2.5`;
const docLineShortClasses = `${docLineClasses} w-[78%]!`;
const docLineMidClasses = `${docLineClasses} w-[86%]! mb-0!`;

const cardTitleClasses = `${blockBase} h-5 w-[60%]`;
const cardLineClasses = `${blockBase} h-3 w-full`;
const cardLineShortClasses = `${cardLineClasses} w-[70%]!`;

const DemandStudioSkeleton = () => {
  return (
    <div className={layoutClasses}>
      <div className={colLeftClasses}>
        <div className={docWrapperClasses}>
          <div className={docTitleClasses} />
          <div className={docLineClasses} />
          <div className={docLineShortClasses} />
          <div className={docLineClasses} />
          <div className={docLineMidClasses} />
        </div>
      </div>
      <div className={colRightClasses}>
        <h6 className={colHeadingClasses}>Revision Comments</h6>
        <div className={cardClasses}>
          <div className={cardTitleClasses} />
          <div className={cardLineClasses} />
          <div className={cardLineShortClasses} />
        </div>
        <div className={cardClasses}>
          <div className={cardTitleClasses} />
          <div className={cardLineClasses} />
          <div className={cardLineShortClasses} />
        </div>
        <div className={cardClasses}>
          <div className={cardTitleClasses} />
          <div className={cardLineClasses} />
          <div className={cardLineShortClasses} />
        </div>
      </div>
    </div>
  );
};

export default DemandStudioSkeleton;
